export default [
  {
    title: '日期',
    key: 'tdate',
    width: 86,
    fixed: true
  },
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    width: 98,
    type: 'report'
  },
  {
    title: '实际消耗',
    key: 'amount',
    width: 102,
    type: 'report'
  },
  {
    title: '曝光',
    key: 'pv',
    width: 102,
    type: 'report'
  },
  {
    title: '点击',
    key: 'clickNum',
    width: 82,
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: 82,
    type: 'report'
  },
  {
    title: '采集点击',
    key: 'collectClickNum',
    width: 82,
    type: 'report'
  },
  {
    title: '收益展示次数',
    key: 'profitPv',
    width: 92,
    type: 'report'
  },
  {
    title: '激活数',
    key: 'downNum',
    width: 82,
    type: 'report'
  },
  {
    title: '注册数',
    key: 'newUserNum',
    width: 82,
    type: 'report'
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    width: 82,
    type: 'report'
  },
  {
    title: '新建角色数',
    key: 'newRoleNum',
    width: 82,
    type: 'report'
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    width: 82,
    type: 'report'
  },
  {
    title: '千次收益成本',
    key: 'throusandProfitPvCost',
    width: 92,
    type: 'report'
  },
  {
    title: '创角率',
    key: 'createRoleRate',
    width: 82,
    type: 'report'
  },
  {
    title: '新增付费创角数',
    key: 'payRoleUserNum',
    width: 102,
    type: 'report'
  },
  {
    title: '新创角付费次数',
    key: 'newRolePayCnt',
    width: 102,
    type: 'report'
  },
  {
    title: '新创角付费成本',
    key: 'newPayCost',
    width: 102,
    type: 'report'
  },
  {
    title: '当日新增付费设备',
    key: 'payActiveDeviceNum',
    width: 108,
    type: 'report'
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    width: 102,
    type: 'report'
  },
  {
    title: '新设备付费率',
    key: 'payActiveDeviceNumRate',
    width: 102,
    type: 'report'
  },
  {
    title: '新设备充值金额',
    key: 'newDeviceMoney',
    width: 102,
    type: 'report'
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    width: 102,
    type: 'report'
  },
  {
    title: '每次付费成本',
    key: 'newRolePayCntCost',
    width: 102,
    type: 'report'
  },
  {
    title: '计划总流水',
    key: 'sumMoney',
    width: 92,
    type: 'report'
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    width: 92,
    type: 'report'
  },
  {
    title: '新激活设备回款率',
    key: 'newDeviceRate',
    width: 108,
    type: 'report'
  },
  {
    title: '激活次留',
    key: 'nextDayRetainRate',
    width: 82,
    type: 'other'
  },
  {
    title: '激活3留',
    key: 'threeDayRetainRate',
    width: 82,
    type: 'other'
  },
  {
    title: '激活7留',
    key: 'sevenDayRetainRate',
    width: 82,
    type: 'other'
  },
  {
    title: '激活30留',
    key: 'thirtyDayRetainRate',
    width: 82,
    type: 'other'
  },
  {
    title: '激活1日ltv',
    key: 'oneDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '激活3日ltv',
    key: 'threeDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '激活7日ltv',
    key: 'sevenDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '激活30日ltv',
    key: 'thirtyDayLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角次留',
    key: 'twoDayCreateRetain',
    width: 72,
    type: 'other'
  },
  {
    title: '创角3留',
    key: 'threeDayCreateRetain',
    width: 72,
    type: 'other'
  },
  {
    title: '创角4留',
    key: 'fourDayCreateRetain',
    width: 72,
    type: 'other'
  },
  {
    title: '创角5留',
    key: 'fiveDayCreateRetain',
    width: 72,
    type: 'other'
  },
  {
    title: '创角6留',
    key: 'sixDayCreateRetain',
    width: 72,
    type: 'other'
  },
  {
    title: '创角7留',
    key: 'sevenDayCreateRetain',
    width: 72,
    type: 'other'
  },
  {
    title: '创角10留',
    key: 'tenDayCreateRetain',
    width: 72,
    type: 'other'
  },
  {
    title: '创角15留',
    key: 'fifteenDayCreateRetain',
    width: 72,
    type: 'other'
  },
  {
    title: '创角30留',
    key: 'thirtyDayCreateRetain',
    width: 72,
    type: 'other'
  },
  {
    title: '创角45留',
    key: 'fortyfiveDayCreateRetain',
    width: 72,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角60留',
    key: 'sixtyDayCreateRetain',
    width: 72,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角75留',
    key: 'seventyfiveDayCreateRetain',
    width: 72,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角90留',
    key: 'ninetyDayCreateRetain',
    width: 72,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角120留',
    key: 'hundredtwentyDayCreateRetain',
    width: 72,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角150留',
    key: 'hundredfiftyDayCreateRetain',
    width: 72,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角180留',
    key: 'hundredeightyDayCreateRetain',
    width: 72,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角1日LTV',
    key: 'oneDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角2日LTV',
    key: 'twoDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角3日LTV',
    key: 'threeDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角4日LTV',
    key: 'fourDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角5日LTV',
    key: 'fiveDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角6日LTV',
    key: 'sixDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角7日LTV',
    key: 'sevenDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角10日LTV',
    key: 'tenDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角15日LTV',
    key: 'fifteenDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角30日LTV',
    key: 'thirtyDayCreateLtv',
    width: 92,
    type: 'other'
  },
  {
    title: '创角45日LTV',
    key: 'fortyfiveDayCreateLtv',
    width: 92,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角60日LTV',
    key: 'sixtyDayCreateLtv',
    width: 92,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角75日LTV',
    key: 'seventyfiveDayCreateLtv',
    width: 92,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角90日LTV',
    key: 'ninetyDayCreateLtv',
    width: 92,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角120日LTV',
    key: 'hundredtwentyDayCreateLtv',
    width: 92,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角150日LTV',
    key: 'hundredfiftyDayCreateLtv',
    width: 92,
    type: 'other',
    auth: 'M21053'
  },
  {
    title: '创角180日LTV',
    key: 'hundredeightyDayCreateLtv',
    width: 92,
    type: 'other',
    auth: 'M21053'
  }
]
